import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-purchase-confirmation',
  templateUrl: './purchase-confirmation.component.html',
  styleUrl: './purchase-confirmation.component.scss'
})
export class PurchaseConfirmationComponent implements OnInit, AfterViewInit {
  @Input() group: UntypedFormGroup;
  @ViewChild('confModal') private modalContent: TemplateRef<never>;
  label: string;
  title: string;
  modal: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
      this.label = this.group.controls.question.value;
      this.title = this.group.controls.explanation.value;
  }

  ngAfterViewInit(): void {
    this.modal = this.modalService.open(this.modalContent, {
          keyboard: false,
          backdrop: 'static',
          centered: true,
          size: 'm',
        });
  }

  confirm(answer: string): void {
    this.group.controls.value.setValue(answer);
    this.modal.close(answer);
  }
}
